

import { Col, Row } from "antd";

import { useEffect, useState } from "react";

import { useNavigate, useParams } from 'react-router-dom';
import { LabListContainer } from "../machineInstalRequest/style";
// import banks from '../../../public/assets/image/banks.png';
// import haghighi from './../../../public/haghighi.xlsx';

const UploadFormat = () => {

    const { id } = useParams();

    const navigate = useNavigate();



    const uploadFile = (item: any) => {
        // UploadFormat

        navigate("/labuser/PaymentUpload/" + id)
    }

    useEffect(() => {

    }, [])









    return (

        <>
            <LabListContainer>
                <Row style={{ textAlign: 'right' }}>
                    <p style={{ fontSize: '16px' }}>

                        اگر آزمایشگاه بنام
                        <span style={{ color: 'green', padding: '0px 10px', display: 'inline-block' }}>
                            شخص
                        </span>
                        می باشد از
                        <span style={{ color: 'green', padding: '0px 10px', display: 'inline-block' }}>
                            اکسل اطلاعات حقیقی
                        </span>

                        استفاده بشود در غیر این صورت اگر بنام
                        <span style={{ color: 'green', padding: '0px 10px', display: 'inline-block' }}>
                            سازمان
                        </span>

                        می باشد از
                        <span style={{ color: 'green', padding: '0px 10px', display: 'inline-block' }}>
                            اکسل اطلاعات حقوقی
                        </span>


                        استفاده کند
                    </p>
                    <Col span={7}>

                        <button
                            style={{ 'background': 'green', 'color': 'white', padding: '7px', border: 'none', borderRadius: '7px' }}
                        ><a style={{ 'color': 'white' }} href='/haghighi.xlsx'
                            download="اطلاعات حقیقی">نمونه فرم اطلاعات حقیقی</a></button>
                    </Col>
                    <Col span={7}>

                        <button
                            style={{ 'background': 'green', 'color': 'white', padding: '7px', border: 'none', borderRadius: '7px' }}
                        ><a href='/hoghoghi.xlsx'
                            style={{ 'color': 'white' }}
                            download="اطلاعات حقوقی">نمونه فرم اطلاعات حقوقی</a></button>
                    </Col>
                    <Col span={6}>

                        <button
                            style={{ 'background': '#5d97ad', 'color': 'white', padding: '7px', border: 'none', borderRadius: '7px' }}
                        ><a style={{ 'color': 'white' }} href='/message.docx'
                            download="نامه">نمونه فرم نامه </a></button>
                    </Col>
                    <Col span={4}>
                        <button
                            onClick={(e) => uploadFile(e)}
                            style={{ 'background': 'green', 'color': 'white', padding: '7px', border: 'none', borderRadius: '7px' }}
                        >آپلود</button>
                    </Col>
                </Row>
                <Row>
                    <div style={{padding:'20px',border:"3px solid black",margin:'20px'}}>
                    <p style={{ textAlign: 'center' ,fontSize: '20px',margin:'20px , 0px',width:'100%',color:"black"}}>راهنما</p>
                <p style={{ textAlign: 'right',fontSize: '16px',color:"black" }}>در نامه اطلاعات حساب نام فروشگاه را با نام آزمایشگاه پر کنید، گزینه Account Multi تیک بخورد. در بخش
                    اطلاعات حساب فقط یک حساب معرفی شود و درصد یا مبلغ را خالی بگذارید ، نهایتا مهر و امضا را در چهارچوب
                    سمت راست برای پذیرنده یا پذیرندگان وارد کنید . هنگام ارسال اطلاعات تصویر کارت ملی و شناسنامه برای
                    حساب های حقیقی و تصویر کارت ملی، شناسنامه و روزنامه رسمی یا آگهی تغییرات برای حساب های حقوقی
                    همراه اطلاعات دیگر ارسال شود.</p>
                <p style={{ textAlign: 'right',fontSize: '16px',color:"black" }}>
                    برای پر کردن نامه نکات زیر را مورد توجه قرار دهید.
                </p>
                <p style={{ textAlign: 'right',fontSize: '16px',color:"black" }}>
                1 -نامه ای که به صورت فایل ورد هست را پرینت و بعد از تکمیل تصویر آن را با مهر و امضا ارسال فرمایید . 
                </p>
                <p style={{ textAlign: 'right',fontSize: '16px',color:"black" }}>
                2 -روی حسابی که اعالم م ی شود نباید قبال دستگاه پوز یا درگاه پرداخت دیگه ای فعال باشد.
                </p>
                <p style={{ textAlign: 'right',fontSize: '16px',color:"black" }}>
                3 -حتما نام صاحب حساب را صحیح و به صورت کامل با پسوند و پیشوند وارد کنید 
                </p>
                <p style={{ textAlign: 'right',fontSize: '16px',color:"black" }}>
                4 -کیفیت نامه ی ارسالی بای د مطلوب و موارد ذکر شده با ید کامال واضح و قابل مشاهده باشد
                </p>
                <p style={{ textAlign: 'right',fontSize: '16px',color:"black" }}>
                5 -اگر حساب به نام شخص هست اکسل حقی قی و اگر به نام مرکز خاصی هست باید اکسل حقوقی تکمیل 
شود.
                </p>
                <p style={{ textAlign: 'right',fontSize: '16px',color:"black" }}>
                6 -فایل نامه باید به صورت تصویر و فایل اکسل هم با فرمت اکسل ارسال شود.
                </p>
                <p style={{ textAlign: 'right',fontSize: '16px',color:"black" }}>
                7 -شماره شبا را در فایل اکسل حتما با IR آغاز کنید.
                </p>
                <p style={{ textAlign: 'right',fontSize: '16px',color:"black" }}>
                8 -لیست بانک های مجاز برای درگاه پرداخت
                </p>
                <p style={{ textAlign: 'right',fontSize: '16px',color:"black" }}>
             
                <img src='/assets/image/banks.png'  />
                
                </p>
                    </div>
            

            </Row>

            </LabListContainer>
        

        </>
    );
};

export default UploadFormat

